
<ng-template #popTemplate>
  @for (item of paginationMetaData; track item) {
    <div class="row">
      <div class="col fw-bold">{{ item.key }}</div>
      <div class="col" (mouseover)="displayValue(item.value)" title="{{ item.value }}"
        [innerText]="item.value.length >= 5 ? item.value.substring(0, 5) + '...' : item.value">
      </div>
    </div>
  }

  @if (moreToDisplay) {
    <button class="btn btn-primary btn-show-hide" (click)="showMore()">
      Show more
    </button>
  }

  @if (!moreToDisplay) {
    <button class="btn btn-primary btn-show-hide" (click)="showLess()">
      Show less
    </button>
  }
</ng-template>

<button type="button"  class="btn btn-primary btn-margin "
  [ngbPopover]="popTemplate" popoverTitle="Dashboard Metadata " placement="right">
  Metadata
</button>





